const listings = {
  hero: {
    title:     "Property listings",
    sub_one:   "{{count}} property available across the UAE",
    sub_other: "{{count}} properties available across the UAE",
  },
  filters: {
    label:    "Filters",
    reset:    "Reset",
    status:   "Status",
    all:      "All",
    sale:     "For sale",
    rent:     "For rent",
    type:     "Type",
    typeAll:  "All types",
    emirates: "Emirates",
    any:      "Any",
    beds:     "Bedrooms",
    maxPrice: "Max price (AED)",
  },
  results: {
    count_one:   "{{count}} property",
    count_other: "{{count}} properties",
    sort:        "Sort:",
    sortDefault: "Default",
    sortAsc:     "Price: low → high",
    sortDesc:    "Price: high → low",
    noResults:   "No properties match your filters.",
    clearFilters:"Clear filters",
  },
};

export default listings;
